import DonateShow from "../components/donate/Show";

export default [
  { name: 'Donate', path: '/donate', component: DonateShow,  }
]
